export default "__VITE_ASSET__C5ja2p5a__"